import { Breadcrumbs, Link, Typography } from '@mui/material';
import {
  useLocation,
  Link as RouterLink,
  useParams,
  matchPath,
} from 'react-router-dom';

import { routes } from '../../routes';

const CustomBreadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const params = useParams();

  const breadcrumbRoutes = pathnames.reduce((acc, _, index) => {
    const currentPath = `/${pathnames.slice(0, index + 1).join('/')}`;

    const matchedRoute = routes.find((route) =>
      matchPath({ path: route.path, end: true }, currentPath)
    );

    if (matchedRoute) {
      const breadcrumb = matchedRoute.breadcrumb.replace(
        /:id/g,
        params.id || 'ID'
      );
      acc.push({ ...matchedRoute, breadcrumb });
    }

    return acc;
  }, []);

  return (
    <Breadcrumbs aria-label='breadcrumb' sx={{ marginBottom: 2 }}>
      <Link
        underline='hover'
        color='inherit'
        component={RouterLink}
        to='/dashboard'
      >
        Inicio
      </Link>
      {breadcrumbRoutes.map((route, index) => {
        const isLast = index === breadcrumbRoutes.length - 1;

        return isLast ? (
          <Typography key={route.path || index} color='text.primary'>
            {route.breadcrumb}
          </Typography>
        ) : (
          <Link
            underline='hover'
            color='inherit'
            component={RouterLink}
            to={route.path}
            key={route.path || index}
          >
            {route.breadcrumb}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
